import { render, staticRenderFns } from "./GridsCrud.vue?vue&type=template&id=9241fec0&scoped=true"
import script from "./GridsCrud.vue?vue&type=script&lang=js"
export * from "./GridsCrud.vue?vue&type=script&lang=js"
import style0 from "./GridsCrud.vue?vue&type=style&index=0&id=9241fec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9241fec0",
  null
  
)

export default component.exports